// import React from 'react';
import React from 'react';
import { Suspense } from 'react';
// import './index.css';
import { Route, Switch, BrowserRouter } from "react-router-dom";
import { Spinner } from '@fluentui/react';
import ReactDOM from 'react-dom';
import { initializeIcons } from '@fluentui/font-icons-mdl2';
// import WebChat from './Bot';

// import App from './App';
const App = React.lazy(
  () =>
    import(/* webpackChunkName: "semtalkapp" */ "./App")
);
// const WebChat = React.lazy(
//   () =>
//     import(/* webpackChunkName: "webchat" */ "./Bot")
// );


if (!(window as any)["iconsInitialized"]) {
  initializeIcons(undefined, { disableWarnings: true });
  (window as any)["iconsInitialized"] = true;
}
let suspfallback = <Spinner></Spinner>;
// const secret = "1E0qUpNSMLo4H9LzCnOyoBNCslvlXEYLf0lRbwvnnLacw2hOnETKJQQJ99CAAC3pKaRAArohAAABAZBS2i9g.5gULq7bBV4JrvYmGOHXVesYCxBzJvEGWr4mN5uQVeYdLRlH5azYiJQQJ99CAAC3pKaRAArohAAABAZBSKooR";

ReactDOM.render(
  <BrowserRouter>
    <Switch>
      {/* <Route path="/foo">
        <div>Foo page</div>
      </Route>
      <Route path="/bot">
        <WebChat
          botButtonText={"Bot - Webchat"}
          chatWindowHeaderTitle={"LENA - der Lösungsorientierte Empathische Navigations-Assistent"}
          description={"Modern sharepoint online webpart to integrate the botframework webchat"}
          botAuthenticationType={"DL-Secret"}
          botDirectLineSecret={secret}
          botDirectLineTokenApiUrl={"https://directline.botframework.com/v3/directline/tokens/generate"}
          botTokenApiResourceId={"<<To be replaced with bot token api's AAD app Id>>"}
          botTokenApiUrl={"<<To be replaced with Custom bot token Api secured by AAD>>"}
          botAvatarUrl={"https://docs.microsoft.com/en-us/azure/bot-service/v4sdk/media/logo_bot.svg?view=azure-bot-service-4.0"}
          avatarSize={30}
          botAvatarInitials={"LB"}
          backgroundColor={"#dfe3ee"}
          bubbleBackground={"#ffffff"}
          bubbleBorderRadius={7}
          bubbleFromUserBackground={"#1d3469"}
          bubbleFromUserBorderRadius={7}
          bubbleFromUserTextColor={"#fff"}
          suggestedActionBackground={"#0078D7"}
          suggestedActionTextColor={"#fff"}
          sendBoxTextWrap={true}
          hideScrollToEndButton={false}
        />
      </Route> */}
      <Route path="/">
        <Suspense fallback={suspfallback}>
          <App />
        </Suspense>
      </Route>
    </Switch>
  </BrowserRouter>,
  document.getElementById('root'));

// const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
// ReactDOM.render(<App />, document.getElementById('root') as HTMLElement);
